module.exports = __webpack_public_path__ + "static/scale-model-of-huron-river-water-trail-in-ann-arbor-michigan-62cfdaa544cc298127927548d1f0360a.png";